import {app} from "../../../app";

export const MFES = {
    AUTH: 'auth',
    GARAGE: 'garage',
    SETTINGS: 'settings'
};

export const MFE_BASE_PATH = {
    ROOT: '/',
    [MFES.AUTH]: '/profile/auth',
    [MFES.GARAGE]: '/profile/garage',
    [MFES.SETTINGS]: '/profile/settings'
};

export const handleMFENavigation = (detail, mfe) => {
    let {navigateTo, action} = detail;

    if (!navigateTo) return;

    switch (mfe) {
        case MFES.AUTH:
            handleAuthNavigation(navigateTo, action);
            break;
        case MFES.GARAGE:
            handleGarageNavigation(navigateTo, action);
            break;
        case MFES.SETTINGS:
            handleSettingsNavigation(navigateTo, action);
            break;
        default:
            break;
    }
}

export const handleAuthNavigation = (navigateTo, action) => {
    let path
    switch (navigateTo) {
        case '/add/onboarding':
            path = `${MFE_BASE_PATH[MFES.GARAGE]}/add/onboarding`;
            break;

        case '/password/update':
            path = `${MFE_BASE_PATH[MFES.SETTINGS]}/password/update`;
            break;

        case '/settings':
            path = `${MFE_BASE_PATH[MFES.SETTINGS]}/settings`;
            break;

        default:
            path= `${MFE_BASE_PATH[MFES.AUTH]}${navigateTo}`;
            break;
    }

    // AUTH MFE shows blank after login, navigate to settings when user is logged in
    if (app.$data.dataStore.user && path === `${MFE_BASE_PATH[MFES.AUTH]}/`) {
        path = MFE_BASE_PATH[MFES.SETTINGS];
    }

    navigate(path, action);
}

export const handleGarageNavigation = (navigateTo, action) => {
    let path = `${MFE_BASE_PATH[MFES.GARAGE]}${navigateTo}`;

    // If trying to navigate to root or user profile from garage, navigate to settings instead
    if (path === `${MFE_BASE_PATH[MFES.GARAGE]}/` || navigateTo.match(/^\/\d+$/)) {
        path = MFE_BASE_PATH[MFES.SETTINGS];
    }

    navigate(path, action);
}

export const handleSettingsNavigation = (navigateTo, action) => {
    let path;
    switch (navigateTo) {
        case '/garage':
            path = MFE_BASE_PATH[MFES.GARAGE];
            break;

        case '/password/reset':
            path = `${MFE_BASE_PATH[MFES.AUTH]}/password/reset`;
            break;

        default:
            path = `${MFE_BASE_PATH[MFES.SETTINGS]}${navigateTo}`;
            break;
    }

    const garageEditRVRegex = /^\/edit\/\d+$/;

    if (garageEditRVRegex.test(navigateTo)) {
        path = `${MFE_BASE_PATH[MFES.GARAGE]}${navigateTo}`;
    }

    navigate(path, action);
}

export const navigate = async (path, action = null) => {
    if (action === 'POP') {
        app.$router.back();
    } else if (path !== app.$route.path) {
        app.$router.push({path: path})
    }
}